import { render, staticRenderFns } from "./CartTotal.vue?vue&type=template&id=fa860e00&"
import script from "./CartTotal.vue?vue&type=script&lang=ts&"
export * from "./CartTotal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseOverlay: require('/app/components/base/Overlay.vue').default})
